import React from "react";

const About = () => {
  const visionPoints = [
    "To become a global market leader in the supply of high-quality, sustainable patchouli oil.",
    "Realizing an independent, competitive Indonesian patchouli oil industry that prospers the community.",
    "Towards an oil industry that produces derivatives from crude oil into several molecules such as MD, Patchouli, and free of iron.",
    "Opening new units in various regions.",
  ];

  const missionPoints = [
    "Stakeholder: Ensuring the welfare of male and female employees.",
    "Empowering farmers: Establishing strong partnerships with local farmers to ensure a consistent supply of raw materials and improve their livelihoods.",
    "Ensuring Quality: Implementing strict production standards to produce patchouli oil with optimal Patchouli Alcohol (PA) content that is recognized in the international market.",
    "Sustainability: Ensuring environmentally friendly and sustainable production processes.",
    "Market Expansion: Expanding the export network to various key destination countries such as (India, China, USA, and Europe).",
  ];

  return (
    <section
      id="about"
      className="py-5"
      style={{
        backgroundColor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <div className="container py-5">
        {/* Section Header */}
        <div className="text-center mb-5" data-aos="fade-down">
          <h5
            className="text-uppercase mb-3"
            style={{
              color: "#b68b40",
              fontSize: "clamp(0.9rem, 2vw, 1rem)",
              fontWeight: "600",
              letterSpacing: "4px",
            }}
          >
            About Company
          </h5>
          <h2
            className="fw-semibold"
            style={{
              color: "#1a3e3f",
              fontSize: "clamp(2rem, 5vw, 2.5rem)",
              marginBottom: "15px",
              lineHeight: "1.2",
            }}
          >
            PT Citra Aroma Indo
          </h2>
          <p
            className="mx-auto"
            style={{
              color: "#6c757d",
              fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
              maxWidth: "700px",
              fontStyle: "italic",
            }}
          >
            Leading Producer of Premium Patchouli Oil
          </p>
          <div
            className="mx-auto"
            style={{
              width: "60px",
              height: "3px",
              background: "#b68b40",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          />
        </div>

        <div className="row g-4 g-lg-5">
          {/* Left Column - Company Profile */}
          <div className="col-12 col-lg-6" data-aos="fade-right">
            <div
              className="h-100 p-4 p-lg-5"
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "24px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.02)",
              }}
            >
              <h3
                className="position-relative pb-3 mb-4"
                style={{
                  color: "#1a3e3f",
                  fontSize: "clamp(1.3rem, 3vw, 1.6rem)",
                  fontWeight: "600",
                }}
              >
                Company Profile
                <span
                  className="position-absolute bottom-0 start-0"
                  style={{
                    width: "50px",
                    height: "3px",
                    background: "#b68b40",
                    borderRadius: "2px",
                  }}
                />
              </h3>

              <div className="d-flex flex-column gap-4">
                <p
                  className="mb-0 d-flex"
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.8",
                    fontSize: "clamp(0.9rem, 2vw, 1rem)",
                  }}
                >
                  <span className="me-2 fw-bold" style={{ color: "#b68b40" }}>
                    •
                  </span>
                  PT. Citra Aroma Indo is a company engaged in the essential oil
                  industry, with a primary focus on the production and
                  distribution of high-quality patchouli oil. Our company is
                  committed to providing natural essential oils processed under
                  maintained production standards to meet the needs of both
                  domestic and international markets.
                </p>

                <p
                  className="mb-0 d-flex"
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.8",
                    fontSize: "clamp(0.9rem, 2vw, 1rem)",
                  }}
                >
                  <span className="me-2 fw-bold" style={{ color: "#b68b40" }}>
                    •
                  </span>
                  Supported by selected raw materials from local farmers and a
                  controlled distillation process, PT. Citra Aroma Indo produces
                  patchouli oil with a strong, distinctive, and consistent aroma
                  character. Our products are widely used as raw materials in
                  the perfume, cosmetic, aromatherapy industries, as well as
                  various other care products.
                </p>

                <div
                  className="p-4 rounded-3"
                  style={{
                    backgroundColor: "rgba(182,139,64,0.05)",
                    borderLeft: "4px solid #b68b40",
                  }}
                >
                  <p
                    className="mb-0"
                    style={{
                      color: "#4a5568",
                      lineHeight: "1.8",
                      fontSize: "clamp(0.9rem, 2vw, 1rem)",
                    }}
                  >
                    <span className="fw-semibold" style={{ color: "#1a3e3f" }}>
                      Our Commitment:
                    </span>{" "}
                    By prioritizing quality, sustainability, and customer trust,
                    we continue to innovate in improving product quality and
                    establishing mutually beneficial partnerships. We are
                    committed to being a trusted partner in providing essential
                    oils that meet industry standards and global market needs.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Vision & Mission */}
          <div className="col-12 col-lg-6" data-aos="fade-left">
            {/* Vision Card */}
            <div
              className="p-4 p-lg-5 mb-4"
              style={{
                backgroundColor: "#1a3e3f",
                borderRadius: "24px",
                color: "white",
                boxShadow: "0 10px 30px rgba(26,62,63,0.1)",
              }}
            >
              <div className="d-flex align-items-center gap-3 mb-4">
                <span className="display-6" style={{ color: "#e8d5b5" }}>
                  🎯
                </span>
                <h3
                  className="mb-0"
                  style={{
                    color: "#e8d5b5",
                    fontSize: "clamp(1.3rem, 3vw, 1.6rem)",
                    fontWeight: "600",
                  }}
                >
                  Our Vision
                </h3>
              </div>

              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                {visionPoints.map((point, index) => (
                  <li
                    key={index}
                    className="d-flex gap-3"
                    style={{
                      lineHeight: "1.6",
                      fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                    }}
                  >
                    <span
                      style={{
                        color: "#b68b40",
                        fontWeight: "bold",
                        minWidth: "24px",
                      }}
                    >
                      {index + 1}.
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Mission Card */}
            <div
              className="p-4 p-lg-5"
              style={{
                background: "linear-gradient(135deg, #b68b40 0%, #a07935 100%)",
                borderRadius: "24px",
                color: "white",
                boxShadow: "0 10px 30px rgba(182,139,64,0.2)",
              }}
            >
              <div className="d-flex align-items-center gap-3 mb-4">
                <span className="display-6" style={{ color: "white" }}>
                  ⚡
                </span>
                <h3
                  className="mb-0"
                  style={{
                    color: "white",
                    fontSize: "clamp(1.3rem, 3vw, 1.6rem)",
                    fontWeight: "600",
                  }}
                >
                  Our Mission
                </h3>
              </div>

              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                {missionPoints.map((point, index) => (
                  <li
                    key={index}
                    className="d-flex gap-3"
                    style={{
                      lineHeight: "1.6",
                      fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                    }}
                  >
                    <span
                      style={{
                        color: "#1a3e3f",
                        fontWeight: "bold",
                        minWidth: "24px",
                      }}
                    >
                      {index + 1}.
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
